import gql from 'graphql-tag';

export const CreateParticipantRestrictivePractice = gql`
  mutation CreateParticipantRestrictivePractice(
    $organizationId: ID!
    $participantId: ID!
    $request: CreateParticipantRestrictivePracticeRequest!
  ) {
    createParticipantRestrictivePractice(
      organizationId: $organizationId
      participantId: $participantId
      request: $request
    ) {
      id
    }
  }
`;
